export default "__VITE_ASSET__4d26c940__"